import React, { useEffect, useCallback } from "react";
import { X } from "lucide-react";

/**
 * Reusable Modal component with consistent styling
 * Matches the Clash Games design system
 */
function Modal({
    isOpen,
    onClose,
    title,
    children,
    closeOnOverlay = true,
    maxWidth = "420px"
}) {
    // Handle escape key
    const handleEscape = useCallback((e) => {
        if (e.key === "Escape") {
            onClose();
        }
    }, [onClose]);

    useEffect(() => {
        if (isOpen) {
            document.addEventListener("keydown", handleEscape);
            document.body.style.overflow = "hidden";
        }
        return () => {
            document.removeEventListener("keydown", handleEscape);
            document.body.style.overflow = "";
        };
    }, [isOpen, handleEscape]);

    if (!isOpen) return null;

    return (
        <div
            className="modal-overlay"
            onClick={closeOnOverlay ? onClose : undefined}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
        >
            <div
                className="modal-content animate-slide-up"
                style={{ maxWidth }}
                onClick={(e) => e.stopPropagation()}
            >
                {title && (
                    <div className="modal-header">
                        <h2 id="modal-title" className="modal-title">
                            {title}
                        </h2>
                        <button
                            className="modal-close"
                            onClick={onClose}
                            aria-label="Close"
                        >
                            <X size={20} />
                        </button>
                    </div>
                )}
                <div className="modal-body">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Modal;
